/**
 * 组件库入口文件
 * 导出所有组件
 */

// 导入基础组件
import {
  install as installBase,
  OnButton,
  OnCollapsiblePanel,
  OnCollapsiblePanelItem,
  OnDialog,
  OnInput,
  OnSelect,
  OnAutocomplete,
  OnMessage,
} from './base';
// 导入业务组件
import {
  CardInformationForm,
  CountrySelect,
  OnCountdownTimer,
  OnErrorMsgPanel,
  OnPaymentOptionSelector,
} from './busi';

// 组件列表
const components = [
  // 基础组件
  OnButton,
  OnCollapsiblePanel,
  OnCollapsiblePanelItem,
  OnDialog,
  OnInput,
  OnSelect,
  OnAutocomplete,

  // 业务组件
  CardInformationForm,
  CountrySelect,
  OnCountdownTimer,
  OnErrorMsgPanel,
  OnPaymentOptionSelector,
];

// 注册安装方法
const install = function(Vue) {
  // 判断是否安装
  if (install.installed) return;
  install.installed = true;

  // 遍历注册所有组件
  components.forEach(component => {
    Vue.component(component.name, component);
  });
};

// 判断是否直接引入文件
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export {
  // 导出的基础组件
  OnButton,
  OnCollapsiblePanel,
  OnCollapsiblePanelItem,
  OnDialog,
  OnInput,
  OnSelect,
  OnAutocomplete,
  OnMessage,

  // 导出的业务组件
  CardInformationForm,
  CountrySelect,
  OnCountdownTimer,
  OnErrorMsgPanel,
  OnPaymentOptionSelector,

  // 导出安装方法
  install,
};

export default {
  install,
};
